export const environment = {
    msalConfig: {
        clientId: '4c0dca9f-1b15-41d8-bc3b-5abe66450395',
        authority: 'https://login.microsoftonline.com/cc74fc12-4142-400e-a653-f98bfa4b03ba',
        redirectUri: '/login/callback',
        postLogoutRedirectUri: '/',
    },
    serviceUrl: 'https://companystore-service-test.eex.ea.com'
};